import { Hidden } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ExternalLink } from '../../../global/components/external-link-modal';
import { GuidedProcessSupportBlock } from '../../../global/components/guided-process-support-block';
import { DividerSection } from '../../../global/components/layout/divider-section';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { PageHeader } from '../../../global/components/layout/page-header';
import { SideBarContent } from '../../../global/components/layout/sidebar-content';
import { TcsmModal } from '../../../global/components/tcsm-modal';
import { WysiwygWithReactLink } from '../../../global/components/wysiwyg-with-react-link';
import { getPodsContent } from '../../../global/ducks/epi-api';
import { getCurrencyFormat } from '../../../global/helpers/format-helpers';
import { isValueEmpty } from '../../../global/helpers/generic-helper';
import { replaceAll } from '../../../global/helpers/string-helpers';
import { TcsmStates } from '../../../root/tcsm-model';
import { AnnuityData, MyCpgPodsSettings, PodContent } from '../mycpg-pod-models';
import { ID3 } from './annuity-plan-pod';

interface Props {
	settings: MyCpgPodsSettings;
}

export function AnnuityPlanDetail(props: Props) {
	const { settings } = props;
	const annuityPlans = useSelector<TcsmStates, AnnuityData>(state => state?.mycpgPodsState?.pods?.annuity_data);
	const dispatch = useDispatch();
	const annuities = annuityPlans?.data?.filter(a => a !== null);
	const [open, setOpen] = React.useState(false);
	const [content, setContent] = useState<any>('');
	const notEnrolled = annuityPlans?.content === PodContent.NOT_ENROLLED;
	const guid = useSelector<TcsmStates, string>(state => state?.authenticatedState.clientGuid);

	const anyID3: boolean = (annuities?.find(plan => plan.source === ID3))?.plan_name?.length > 0;

	const newAnnuityPlanMessage = anyID3 ? settings?.newAnnuityPlanMessageID3 : settings?.newAnnuityPlanMessage;
	const annuityPlanDetailAdditionalInfoText = anyID3 ? settings?.annuityPlanDetailAdditionalInfoTextID3 : settings?.annuityPlanDetailAdditionalInfoText;


	useEffect(() => {
		dispatch(getPodsContent(annuityPlans?.plan_details, (data) => setContent(data?.contentHtml)));
	}, []);

	const handleClose = () => {
		setOpen(false);
	};

	const renderPlans = () => {
		return (
			<>
				{
					annuities?.map(plan =>
						<div>
							<ContentSpacer>
								<h2>{plan.plan_name}</h2>
							</ContentSpacer>
							{
								plan.source !== ID3 && settings?.enableFtj ?
									<>
										<ContentSpacer>
											<p>{replaceAll(settings?.policyNumberLabel, '{policy#}', plan?.policy_id)}</p>
										</ContentSpacer>
										<ContentSpacer>
											<p><ExternalLink linkUrl={replaceAll(settings?.annuityPlanFtjRedirect, '{guid}', guid)} linkText={settings?.annuityPlanFtjLinkText} /></p>
										</ContentSpacer>
									</> :
									<>
										<ContentSpacer>
											<p>{settings?.policyNumberLabel?.replace('{policy#}', plan?.policy_id)}</p>
										</ContentSpacer>
										{
											!isValueEmpty(plan?.current_fund_value) &&
											<ContentSpacer>
												<p className='h3-styled'>{getCurrencyFormat(plan?.current_fund_value)}</p>
												<p className='grey-caption'>{settings?.annuityPlanDetailCurrentValueLabel}</p>
											</ContentSpacer>
										}
										{
											!isValueEmpty(plan?.surrender_value) &&
											<ContentSpacer>
												<p className='h3-styled'>{getCurrencyFormat(plan?.surrender_value)}</p>
												<p className='grey-caption'><span className='red-text'>*</span>{settings?.surrenderValueLabel}</p>
											</ContentSpacer>
										}
										{
											plan?.in_distribution &&
											<ContentSpacer>
													<div dangerouslySetInnerHTML={{ __html: settings.distributionMessageID3 }} />
											</ContentSpacer>
										}
				
									</>

							}
						</div>,
					)
				}

			</>);
	};

	return (
		<>
			<PageHeader headerText={settings?.annuityPlanDetailTitle} />
			<Hidden mdUp>
				<SideBarContent>
					<GuidedProcessSupportBlock title={settings?.annuityGpsTitle} contents={settings?.annuityGps} />
				</SideBarContent>
			</Hidden>
			{
				notEnrolled ?
					<DividerSection removeDivider>
						<WysiwygWithReactLink content={settings?.annuityPlanNotEnrolledMessage} />
					</DividerSection> :
					<>
						<TcsmModal
							open={open}
							handleClose={handleClose}
						>
							<WysiwygWithReactLink content={content} />
						</TcsmModal>
						<DividerSection removeDivider>
							{
								renderPlans()
							}
							<ContentSpacer>
								<WysiwygWithReactLink content={newAnnuityPlanMessage} />
							</ContentSpacer>
							<WysiwygWithReactLink content={annuityPlanDetailAdditionalInfoText} />
						</DividerSection>
					</>
			}
		</>

	);
}